import { isImage, isVideo } from './getAttachmentType';

export const getImageDimensions = (
  file: File
): Promise<{ width: number; height: number } | null> => {
  return new Promise((resolve) => {
    if (!isImage(file.type)) {
      resolve(null);
      return;
    }

    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };

    img.src = url;
  });
};

export const getVideoThumbnail = (
  file: File
): Promise<{ width: number; height: number; thumbnailUrl: string } | null> => {
  return new Promise((resolve) => {
    if (!isVideo(file.type)) {
      resolve(null);
      return;
    }

    const video = document.createElement('video');
    const url = URL.createObjectURL(file);
    video.preload = 'auto';
    video.muted = true;

    video.onloadeddata = () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d')?.drawImage(video, 0, 0);

      canvas.toBlob(
        (blob) => {
          URL.revokeObjectURL(url);
          if (blob) {
            resolve({
              width: video.videoWidth,
              height: video.videoHeight,
              thumbnailUrl: URL.createObjectURL(blob)
            });
          } else {
            resolve(null);
          }
        },
        'image/jpeg',
        0.75
      );
    };

    video.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };

    video.src = url;
  });
};
